import {LocalDateTimeString, Workday, WorkspaceReservation} from '../apiTypes';
import {TimeslotsState} from '../stateTypes';

export const reservationCompare = <T extends {localStart: LocalDateTimeString; localEnd: LocalDateTimeString}>(
  a: T,
  b: T,
) => a.localStart.localeCompare(b.localStart);

export const registerMutation = (state: TimeslotsState, mutation: TimeslotsState['pendingMutations'][number]) => {
  state.pendingMutations.push(mutation);
};

export const resolveMutation = (
  state: TimeslotsState,
  type: TimeslotsState['pendingMutations'][number]['type'],
  requestId: string,
) => {
  state.pendingMutations = state.pendingMutations.filter(
    ({type: t, requestId: id}) => !(t === type && id === requestId),
  );
};
